export default __webpack_public_path__ + "static/media/avatar_125.c8bd091c.png";